export default __webpack_public_path__ + "static/media/account-circle-grey.80a73925.svg";